import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getDeclinedItems(invoiceId, params) {
        return Axios.get(`${baseURL}billing/invoice/declined/${invoiceId}`, {
            params
        }).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    insertItem(params) {
        return Axios.post(
            `${baseURL}billing/invoice-item/reInsertInvoiceItem`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    }
};
